import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export type Trls = Record<string, string>;
type FilterValue = string;
type IsLoad = boolean;

export enum TranslationsFilterType {
    Key = 'key',
    Value = 'value',
}

interface FilteredTrl {
    key: string;
    text: string;
}

// ----------------------- actions -------------------------------------
const SET_ALL_TRANSLATIONS = 'SET_ALL_TRANSLATIONS';
const SET_IS_LOAD_FILTERED_TRANSLATIONS = 'SET_IS_LOAD_FILTERED_TRANSLATIONS';
const SET_FILTERED_TRANSLATIONS = 'SET_FILTERED_TRANSLATIONS';
const SET_FILTER_TYPE_TRANSLATIONS = 'SET_FILTER_TYPE_TRANSLATIONS';
const SET_FILTER_VALUE_TRANSLATIONS = 'SET_FILTER_VALUE_TRANSLATIONS';

interface PayloadTypes {
    [SET_ALL_TRANSLATIONS]: Trls;
    [SET_IS_LOAD_FILTERED_TRANSLATIONS]: IsLoad;
    [SET_FILTERED_TRANSLATIONS]: FilteredTrl[];
    [SET_FILTER_TYPE_TRANSLATIONS]: TranslationsFilterType;
    [SET_FILTER_VALUE_TRANSLATIONS]: FilterValue;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setAllTranslations = ActionCreator(SET_ALL_TRANSLATIONS);
export const setLoadFilteredTranslations = ActionCreator(SET_IS_LOAD_FILTERED_TRANSLATIONS);
export const setFilteredTranslations = ActionCreator(SET_FILTERED_TRANSLATIONS);
export const setFilterType = ActionCreator(SET_FILTER_TYPE_TRANSLATIONS);
export const setFilterValue = ActionCreator(SET_FILTER_VALUE_TRANSLATIONS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface TranslationsState {
    trls: Trls;
    isLoad: IsLoad;
    filteredTrls: FilteredTrl[];
    filterType: TranslationsFilterType;
    filterValue: FilterValue;
}

const TRANSLATIONS_INITIAL_STATE: TranslationsState = {
    trls: {},
    isLoad: false,
    filteredTrls: [],
    filterType: TranslationsFilterType.Key,
    filterValue: '',
};

export default createReducer<TranslationsState, PayloadTypes>(TRANSLATIONS_INITIAL_STATE, {
    [SET_ALL_TRANSLATIONS]: (state, { payload }) => ({
        ...state,
        trls: payload,
    }),
    [SET_IS_LOAD_FILTERED_TRANSLATIONS]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_FILTERED_TRANSLATIONS]: (state, { payload }) => ({
        ...state,
        filteredTrls: payload,
    }),
    [SET_FILTER_TYPE_TRANSLATIONS]: (state, { payload }) => ({
        ...state,
        filterType: payload,
    }),
    [SET_FILTER_VALUE_TRANSLATIONS]: (state, { payload }) => ({
        ...state,
        filterValue: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
